module.exports = __webpack_public_path__ + "img/illu_token.5929d45f.svg";